const $ = jQuery.noConflict();

const loadMASession = () => {
  $('header .session').each(function () {
    const $session = $(this);
    const url = $session.data('url');
    if (!url || url.length === 0) {
      return
    }

    const load =() => {
      const loader = document.createElement('script');
      loader.type = 'text/javascript';
      loader.id = 'ma-session-loader';
      loader.onload = () => {
        $session.addClass('loaded loading-success');
      }
      loader.onerror = () => {
        $session.addClass('loaded');
        $session.addClass('loaded loading-failed');
      }
      loader.src = url;
      document.head.appendChild(loader);
    }

    const keepMenuOpen = () => {
      $session.find('input#avatar_menu_toggle:checkbox').prop('checked', true);
    }

    // close menu when clicking outside
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest("header .session").length
      ) {
        $session.find('input#avatar_menu_toggle:checkbox:checked').prop('checked', false);
      }
    });


    const reload = () => {
      console.debug('Reloading session');
      $session.removeClass('loaded loading-success loading-failed');
      $session.find('#profile-menu').remove();
      $session.find('script#ma-session-loader').remove();
      load();
    }

    const resizeIframe = (height) => {
      const $iframe = $session.find('iframe.ma');
      if ($iframe.length === 0) {
        return;
      }
      $iframe.css('height', `${height + 20}px`).addClass('loaded');
    }

    window.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'ma_session') {
        console.debug('Session iframe message', e.data);
        if (e.data.height) {
          resizeIframe(e.data.height);
        }
        if (e.data.action === 'keep') {
          keepMenuOpen();
        }
        if (e.data.action === 'close') {
          setTimeout(() => {
            reload();
          }, e.data.wait || 1);
        }
      }
    });
    load();
  });
}

export default loadMASession;
